import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { actionsWidths, resultsWidths, statsWidths } from "../../configs/columns.config";
import { UtilityService } from "../../../../../core/services/utility.service";
import { defaultDeleteConfirmationParams } from "../../../../../core/models/default-delete-confirmation-params";
import { ConfirmService } from "../../../../../core/services/confirm.service";
import { PlanFactTableDataGroupedByMonths, Product, Team } from "../../types/table-data.types";
import { PlanFactApiService } from "../../services/plan-fact-api.service";
import { PlanFactService } from "../../services/plan-fact.service";
import { DeleteFocusDirective } from "../../../../../shared/directives/delete-focus.directive";
import { FactValueComponent } from "../fact-value/fact-value.component";
import { GroupedValueColumnsComponent } from "../grouped-value-columns/grouped-value-columns.component";

@Component({
  selector: 'app-plan-fact-reviewer-row',
  standalone: true,
  imports: [
    DeleteFocusDirective,
    FactValueComponent,
    GroupedValueColumnsComponent
  ],
  templateUrl: './plan-fact-reviewer-row.component.html',
  styleUrls: [
    './plan-fact-reviewer-row.component.scss',
    '../plan-fact-components-styles.scss'
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PlanFactReviewerRowComponent {
  selectedYear = input.required<number>();
  monthData = input.required<PlanFactTableDataGroupedByMonths>();
  product = input.required<Product>();
  team = input.required<Team>();

  private utilityService: UtilityService = inject(UtilityService);
  private confirmService: ConfirmService = inject(ConfirmService);
  private planFactApiService: PlanFactApiService = inject(PlanFactApiService);
  private planFactService: PlanFactService = inject(PlanFactService);

  public readonly resultsWidths = resultsWidths;
  public readonly statsWidths = statsWidths;
  public readonly actionsWidths = actionsWidths;

  public formatNumberValue(value: number | string, fractional: number = 0): string {
    return this.utilityService.formatNumberForDisplay({
      value: +value,
      fractional: { value: fractional },
      numberSeparator: { separator: ' ' }
    });
  }

  public formatNumberValueToRubles(value: number | string): string {
    return this.utilityService.formatBudgetValue({value: Number(value)});
  }

  public async handleDeleteReviewerButtonClick(id: number, monthNumber: number): Promise<void> {
    const isConfirmed = await this.confirmService.getDeleteConfirmation({
      ...defaultDeleteConfirmationParams,
      titleText: 'Удалить руководителя',
      description: '<p> Вы уверены, что хотите удалить руководителя?</p> <p>Все менеджеры также будут удалены.</p>'
    });

    if (!isConfirmed) { return; }

    this.planFactApiService.deleteReviewer(id).subscribe({
      next: () => {
        this.planFactService.openMonthData({
          monthNumber: monthNumber,
          selectedYear: this.selectedYear()
        }).then()
      }
    })
  }

  public isAnyTeamInProduct(product: Product): boolean {
    return !!product.teams.length;
  }
}
